import Vue from "vue"
import App from "./App.vue"
// for develop
//import firebase from "firebase"
import firebase from "firebase/app";
import "firebase/analytics"
import router from "./router"

Vue.config.productionTip = false

fetch('/__/firebase/init.json').then(async response => {
  firebase.initializeApp(await response.json());
  firebase.analytics();
}).then(() => {
  new Vue({
    router,
    render: h => h(App),
  }).$mount("#app")
});

// new Vue({
//   router,
//   render: h => h(App),
// }).$mount("#app")